export const DEFAULT_DEBOUNCE = 500 //ms
export const DEFAULT_RETRY = 500